import { createFileRoute } from "@tanstack/react-router";
import DashboardLeads from "@/pages/DashboardLeads";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dashboard/lead-uri/")({
  head: () => routeHead("/dashboard/lead-uri/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><DashboardLeads /></SubscribedRoute>
  );
}
